import { SagaIterator } from 'redux-saga';
import { call, cancel, put, takeEvery } from 'redux-saga/effects';
import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  HTTP_METHOD,
  ProduktRequested,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { AnyAction } from 'redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { DiagnoseDetailsModel } from '@ps20/bff-models';
import { CheckoutActions } from '../checkout.actions';

export enum DiagnoseDetailsListRequestActions {
  DIAGNOSEDETAILSLIST_REQUEST_SUCCESSFULL = 'DIAGNOSEDETAILSLIST_REQUEST_SUCCESSFULL',
  DIAGNOSEDETAILSLIST_REQUEST_FAILED = 'DIAGNOSEDETAILSLIST_REQUEST_FAILED',
}

export const URL_DIAGNOSEDETAILSLIST = '/privatschutz/api/diagnosedetails';

export function* watchDiagnoseDetailsListRequest(): SagaIterator {
  yield takeEvery(
    GlobalActions.PRODUKT_REQUESTED,
    safeSaga(getDiagnoseDetailsListSaga, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    DiagnoseDetailsListRequestActions.DIAGNOSEDETAILSLIST_REQUEST_SUCCESSFULL,
    safeSaga(successCallback, App.SHOP_CHECKOUT),
  );
}

export function* getDiagnoseDetailsListSaga(action: GlobalAction<ProduktRequested>): SagaIterator {
  if (action.payload.appId !== App.TKV) {
    return yield cancel();
  }
  const globalPut = GlobalPut.getInstance();
  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequest({
      appId: App.SHOP,
      method: HTTP_METHOD.GET,
      body: '',
      url: URL_DIAGNOSEDETAILSLIST,
      successEvent: DiagnoseDetailsListRequestActions.DIAGNOSEDETAILSLIST_REQUEST_SUCCESSFULL,
      errorEvent: DiagnoseDetailsListRequestActions.DIAGNOSEDETAILSLIST_REQUEST_FAILED,
    }),
  );
}

export function* successCallback(successAction: AnyAction): SagaIterator {
  const list = (successAction.payload as DiagnoseDetailsModel).diagnosedetails;
  yield put({
    type: CheckoutActions.DIAGNOSE_DETAILS_LIST_RECEIVED,
    payload: list,
  });
}
